import { keyframes } from 'styled-components';

export const pulse = keyframes`
  0% {
    opacity: .5;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: .5;
  }
`;

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const animations = {
	pulse,
	rotate,
};

export default animations;
